import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { flipAnimation, slideAnimation } from './booking-localizer.animation';
import { BookingLocalizerService } from './booking-localizer.service';
import { ConfigService } from 'src/app/shared/services/config/config.service';

@Component({
  selector: 'app-booking-localizer',
  templateUrl: './booking-localizer.component.html',
  styleUrls: ['./booking-localizer.component.scss'],
  animations: [flipAnimation, slideAnimation]
})
export class BookingLocalizerComponent {
  public flipAnimationState: boolean | null;
  public slideAnimationState: boolean | null;

  public form: FormGroup;
  public submitted: boolean;
  public errored: boolean;

  constructor(
    private config: ConfigService,
    private _bookingLocalizerService: BookingLocalizerService
  ) {
    this.submitted = false;

    this.form = new FormGroup({
      localizer: new FormControl('', [Validators.required, this.validateLocalizer.bind(this)]),
      firstName: new FormControl('', Validators.required)
    });

    this.initializeAnimations(this.config.screen.isSM);

    this.config.screen.onIsSMChanges().subscribe(
      (isMobile) => this.initializeAnimations(isMobile)
    );
  }

  private validateLocalizer(c: FormControl) {
    const value = c.value || '';

    return (value.includes('-') || +value < 2147483647) ? null : { invalidLocalizer: true };
  }

  public onSubmit(): void {
    const { localizer, firstName } = this.form.value;
    this.submitted = true;
    this.errored = false;

    if (this.form.valid) {
      this._bookingLocalizerService.getHashFromLocalizer(localizer, firstName).subscribe(
        (hash: string) => {
          this.form.reset();
          this.submitted = false;

          const searchLocation = `${this.config.checkin.baseCheckinUrl}/${hash}`;
          const open = window.open(searchLocation);

          if (open === null || typeof(open) === 'undefined') {
            window.location.href = searchLocation;
          }
        },
        () => this.errored = true
      );
    }
  }

  public removeErrored(): void {
    this.errored = false;
  }

  private initializeAnimations(isMobile: boolean): void {
    this.flipAnimationState = isMobile ? null : false;
    this.slideAnimationState = isMobile ? false : null;
  }

  public toggleExplanation(): void {
    const isMobile = this.config.screen.isSM;

    this.flipAnimationState = isMobile ? null : !this.flipAnimationState;
    this.slideAnimationState = isMobile ? !this.slideAnimationState : null;
  }
}
